import { FC } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "mui";
import { useFormik } from "formik";

import styles from "modules/Auth/components/VerificationForm/VerificationForm.module.scss";
import { LoginStep } from "constants/loginSteps";

interface VerificationFormProps {
  onSend: (value: LoginStep) => void;
}

const VerificationForm: FC<VerificationFormProps> = ({
  onSend,
}: VerificationFormProps) => {
  const formik = useFormik({
    initialValues: {
      verificationMethod: "app",
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
      onSend(LoginStep.Authentication);
    },
  });

  return (
    <Box>
      <Box>
        <h1>VERIFY YOUR IDENTITY</h1>
      </Box>
      <Box className={styles.description}>
        <Typography variant="subtitle1">
          Select a way to verify
        </Typography>
      </Box>
      <form onSubmit={formik.handleSubmit}>
        <Box className={styles.radioGroup}>
          <RadioGroup
            name="verificationMethod"
            value={formik.values.verificationMethod}
            onChange={formik.handleChange}
          >
            <FormControlLabel
              value="app"
              control={<Radio />}
              label="Authenticator App"
            />
            <FormControlLabel value="email" control={<Radio />} label="Email" />
            <FormControlLabel value="sms" control={<Radio />} label="SMS" />
          </RadioGroup>
        </Box>
        <Button
          className={styles.continueButton}
          variant="contained"
          type="submit"
        >
          Continue
        </Button>
      </form>
    </Box>
  );
};

export default VerificationForm;
